module.exports = __webpack_public_path__ + "img/KPI.1fe9170e.png";